<template>
  <div id="app" class="app-bg">
    <navbar></navbar>
    <router-view />
    <!-- <main-footer v-if="windowWidth < 600"></main-footer> -->
  </div>
</template>
<style lang="scss">
@import "./styles/main.scss";
</style>
<script>
import Navbar from '@/shared/Navbar.vue'
import Footer from '@/shared/Footer.vue'
import Hammerjs from 'hammerjs'

export default {
  metaInfo: {
    meta: [
      {
        property: "description",
        content: `Soy un profesional con la capacidad de asesorar empresas y acompañar a los empresarios en el devenir de sus negocios.`,
      },
      {
        property: "og:type",
        content: "website",
      },
      // {
      //   property: 'og:image',
      //   content: '/meta-image.jpg'
      // },
      {
        property: "og:title",
        content: "Circulo Agencia",
      },
      {
        property: "og:site_name",
        content: "Circulo",
      },
      {
        property: "og:description",
        content: `Soy un profesional con la capacidad de asesorar empresas y acompañar a los empresarios en el devenir de sus negocios.`,
      },
      {
        property: "og:url",
        content: "https://circulo.digital",
      },
    ],
  },
  mounted() {
    const hammer = new Hammerjs(document.body);
    hammer.domEvents = true;
    hammer.on("swipeleft", (ev) => {
      if (ev.target.classList.value.includes("m-navbar")) {
        if (ev.target.classList.value.includes("m-navbar")) {
          this.$store.commit("closeNavbar");
        }
      } else {
        if (
          this.sections.counter < this.sections.array.length - 1 &&
          this.windowWidth <= 768
        ) {
          this.$store.commit("setSectionAnim", "section-right");
          this.$store.commit("setSectionCounter", "up");
        }
      }
    });
    hammer.on("swipeup", (ev) => {
      if (
        this.sections.counter < this.sections.array.length - 1 &&
        this.windowWidth > 768
      ) {
        this.$store.commit("setSectionAnim", "section-up");
        this.$store.commit("setSectionCounter", "up");
      }
    }),
      hammer.on('swiperight', (ev) => {
        if (ev.target.classList.value.includes('m-navbar')) {
          if (ev.target.classList.value.includes('m-navbar')) {
            this.$store.commit('closeNavbar')
          }
        } else {
          if (this.sections.counter > 0 && this.windowWidth <= 768) {
            this.$store.commit('setSectionAnim', 'section-left')
            this.$store.commit('setSectionCounter', 'down')
          }
        }
      })
    hammer.on('swipedown', (ev) => {
      if (this.sections.counter > 0 && this.windowWidth > 768) {
        this.$store.commit("setSectionAnim", "section-down");
        this.$store.commit("setSectionCounter", "down");
      }
    });
    hammer.on("tap", (ev) => {
      if (
        !ev.target.classList.value.includes("m-navbar") &&
        this.activeNavbar
      ) {
        this.$store.commit("closeNavbar");
      }
    });
    if (window.innerWidth <= 768) {
      hammer.get("swipe").set({ direction: Hammer.DIRECTION_HORIZONTAL });
    } else {
      hammer.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768) {
        hammer.get("swipe").set({ direction: Hammer.DIRECTION_HORIZONTAL });
      } else {
        hammer.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
      }
    });

    // if (window) {
    //   window.gtag('event', 'conversion', {'send_to': 'AW-11025123416/7uYYCMLg3oMYENiQmIkp'})
    // }
  },
  methods: {
    openNavbar() {
      if (!this.$store.state.activeNavbar && window.innerWidth <= 768) {
        this.$store.commit("openNavbar");
      }
    },
    closeNavbar() {
      if (this.$store.state.activeNavbar && window.innerWidth <= 768) {
        this.$store.commit("closeNavbar");
      }
    },
    elemPositionForeground(top, amount) {
      return `top: calc(${top}% - ${amount}px * ${this.$store.state.sections.counter})`;
    },
  },
  components: {
    navbar: Navbar,
    "main-footer": Footer,
  },
  computed: {
    activeNavbar() {
      return this.$store.state.activeNavbar;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    sections() {
      return this.$store.state.sections;
    },
  },
};
</script>

<!-- <style lang="scss">
.app-bg {
  background: linear-gradient(
    73.52deg,
    #e1d1f4 5.33%,
    #fae5e7 34.68%,
    #fae5e7 63.15%,
    #ece3e9 68.48%,
    #c7e1f1 78.27%,
    #8cdcfd 92.5%,
    #83dcff 94.28%
  );
}
</style> -->
